import { render, staticRenderFns } from "./sidebar-login.vue?vue&type=template&id=adaa7026"
import script from "./sidebar-login.vue?vue&type=script&lang=js"
export * from "./sidebar-login.vue?vue&type=script&lang=js"
import style0 from "./sidebar-login.vue?vue&type=style&index=0&id=adaa7026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports